import { join } from 'path';
import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { Card, CardBody, CardHeader, CardFooter, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import entityComposition from '../common/classes/entityComposition';
import EditorComponent from '../editor/editorComponent';
import FormModal from '../forms/formModal';
import SaveButton from '../common/controls/saveButton';
import Loader from '../common/loader';
class IssueEditor extends Component {
  constructor(props) {
    super(props);
    this.getSectionIndex = this.getSectionIndex.bind(this);
    this.getSectionFormat = this.getSectionFormat.bind(this);
    this.getSections = this.getSections.bind(this);
    this.handleSelectSection = this.handleSelectSection.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      sectionIndex: null
    };
  }
  getSectionIndex() {
    const sectionIndex = this.state.sectionIndex;
    if (sectionIndex) {
      return sectionIndex;
    }

    // return the first section.
    const sections = this.getSections();
    if (sections && sections.length > 0) {
      return sections[0].label;
    }
    // what should we return as default?
    return 'General';
  }
  getSections() {
    const _this$props$issue$act = this.props.issue.active.format,
      format = _this$props$issue$act === void 0 ? {} : _this$props$issue$act;
    if (format && format.children) {
      // Return only visible sections (i.e. visible is not set to false)
      return format.children.map(child => ({
        label: child.label,
        format: child
      })).filter(section => section.format.visible !== undefined && section.format.visible === true || section.format.visible === undefined);
    }
    return [];
  }
  getSectionFormat() {
    const sectionKey = this.getSectionIndex();
    const sections = this.getSections();
    const section = sections.find(currentSection => currentSection.label === sectionKey);
    return section ? section.format : undefined;
  }
  handleSelectSection(sectionkey) {
    this.setState({
      sectionIndex: sectionkey
    });
  }
  handleChange(_ref) {
    let path = _ref.path,
      value = _ref.value,
      changeModifiers = _ref.changeModifiers;
    const _this$props = this.props,
      issueActions = _this$props.issueActions,
      issueID = _this$props.issueID;
    // create a change action with the new info.
    // need to prepend the content object to this keypath
    issueActions.change(issueID, join('content', path), value, changeModifiers);
  }
  render() {
    const _this$props2 = this.props,
      handleSave = _this$props2.handleSave,
      _this$props2$issue = _this$props2.issue,
      active = _this$props2$issue.active,
      loading = _this$props2$issue.loading,
      footer = _this$props2.footer,
      containerMaxHeight = _this$props2.containerMaxHeight,
      saveState = _this$props2.saveState,
      _this$props2$issueAct = _this$props2.issueActions,
      operationComplete = _this$props2$issueAct.operationComplete,
      operationPending = _this$props2$issueAct.operationPending;

    // static now, but can re-size if additional items are added to the card header
    const headerHeight = 59;
    const footerHeight = 59;
    const ready = active && active.issueType;
    const sectionIndex = this.getSectionIndex();
    const sectionFormat = this.getSectionFormat();
    const sections = this.getSections();
    let sectionKeyPath = null;
    if (sectionFormat && sectionFormat.children) {
      sectionKeyPath = sectionFormat.contentPath ? sectionFormat.contentPath : '/';
    }
    return /*#__PURE__*/React.createElement(Card, {
      id: "detail-card-header",
      className: "t-section-panel"
    }, /*#__PURE__*/React.createElement(CardHeader, {
      style: {
        paddingBottom: 0,
        paddingLeft: 10,
        paddingRight: 10
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        float: 'right',
        paddingBottom: active.id ? 0 : 20
      }
    }, /*#__PURE__*/React.createElement(SaveButton, {
      onSave: handleSave,
      saveState: saveState,
      className: "t-idvp-save",
      size: "sm"
    })), /*#__PURE__*/React.createElement(Nav, {
      tabs: true,
      style: {
        paddingTop: active.id ? 11 : 0
      }
    }, sections.map(section => /*#__PURE__*/React.createElement(NavItem, {
      key: "KEY_".concat(kebabCase(section.label)),
      className: "t-i-nav-section-".concat(kebabCase(section.label))
    }, /*#__PURE__*/React.createElement(NavLink, {
      className: classnames({
        active: section.label === sectionIndex
      }),
      onClick: () => {
        this.handleSelectSection(section.label);
      }
    }, section.label))))), /*#__PURE__*/React.createElement(CardBody, {
      style: {
        maxHeight: containerMaxHeight - headerHeight - footerHeight,
        overflow: 'auto'
      }
    }, /*#__PURE__*/React.createElement(Loader, {
      loaded: !loading
    }, /*#__PURE__*/React.createElement(TabContent, {
      activeTab: sectionIndex
    }, sections.length ? sections.map(section => /*#__PURE__*/React.createElement(TabPane, {
      tabId: section.label,
      key: "KEY_".concat(kebabCase(section.label)),
      className: "t-i-nav-pane-".concat(kebabCase(section.label))
    }, ready ? /*#__PURE__*/React.createElement(EditorComponent, {
      reduxEntity: "issue",
      path: sectionKeyPath,
      format: sectionFormat,
      onChange: this.handleChange,
      operationComplete: operationComplete,
      operationPending: operationPending
    }) : null)) : /*#__PURE__*/React.createElement("h3", {
      className: "t-ie-edit-header"
    }, "Select an issue to edit or click to create"))), /*#__PURE__*/React.createElement(FormModal, null)), footer ? /*#__PURE__*/React.createElement(CardFooter, {
      style: {
        paddingLeft: 10,
        paddingRight: 10
      }
    }, footer) : null);
  }
}
IssueEditor.defaultProps = {
  saveState: 'disabled',
  issueID: null,
  footer: null
};
IssueEditor.propTypes = {
  handleSave: PropTypes.func.isRequired,
  containerMaxHeight: PropTypes.number.isRequired,
  issueID: PropTypes.string,
  footer: PropTypes.node,
  issue: PropTypes.shape({
    active: PropTypes.shape({
      issueType: PropTypes.shape({}),
      // the complete issue type object
      content: PropTypes.shape({}),
      format: PropTypes.shape({}),
      id: PropTypes.string
    }),
    loading: PropTypes.bool
  }).isRequired,
  issueActions: PropTypes.shape({
    change: PropTypes.func,
    operationPending: PropTypes.func,
    operationComplete: PropTypes.func
  }).isRequired,
  saveState: PropTypes.string
};
export { IssueEditor as TestIssueEditor };
export default entityComposition(IssueEditor, ['issue'], {}, []);